import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import StoreCategoryService from '../storeCategoryService';
import { StoreCategoryState } from '../types/StoreCategoryState';

const initialState: StoreCategoryState = {
  data: [],
  status: 'idle',
};

export const getStoreCategoryAction = createAsyncThunk(
  'storeCategory/getStoreCategoryAction',
  StoreCategoryService.getStoreCategory,
);

const storeCategorySlice = createSlice({
  name: 'storeCategory',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStoreCategoryAction.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getStoreCategoryAction.fulfilled, (state, action) => {
        state.status = 'success';
        state.data = action.payload.categories;
      })
      .addCase(getStoreCategoryAction.rejected, (state) => {
        state.status = 'error';
      });
  },
});

export const { reducer } = storeCategorySlice;
